import { Node, ReactNodeViewRenderer } from '@tiptap/react'
import Component from './component'

export const Columns = Node.create({
	name: 'columns',
	group: 'block',
	content: 'column column*',
	parseHTML() {
		return [{ tag: this.name }]
	},
	renderHTML({ node }) {
		return [
			this.name,
			{
				'data-type': 'columns',
				border: '0',
				cellpadding: '0',
				cellspacing: '0',
				width: '100%',
				style: 'width: 100%; border-collapse: collapse;',
			},
			0,
		]
	},
	addNodeView() {
		return ReactNodeViewRenderer(Component)
	},
})
